export default __webpack_public_path__ + "static/media/adonai_3.6cd79d9e.jpg";